import uploadshomefeaturesHeroContentfeature01ImagebannerPng from "$lib/data/generated/uploads/home/Features Hero Content/Feature 01 Image/banner.png";

export const uploads = {
  "uploads/home/Features Hero Content/Feature 01 Image/banner.png": uploadshomefeaturesHeroContentfeature01ImagebannerPng
};